import { render, staticRenderFns } from "./FileEdit.vue?vue&type=template&id=871b9a8e&scoped=true"
import script from "./FileEdit.vue?vue&type=script&lang=js"
export * from "./FileEdit.vue?vue&type=script&lang=js"
import style0 from "./FileEdit.vue?vue&type=style&index=0&id=871b9a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871b9a8e",
  null
  
)

export default component.exports